import { StateCreator } from 'zustand';
import { Workflow, WorkflowNode, WorkflowParameter } from '../api/model.ts';
import { ReactFlowInstance } from 'reactflow';

type State = {
  selectedNode: WorkflowNode | null;
  selectedEmbedWorkflows: Workflow[];
  mainReactFlowInstance: ReactFlowInstance | null;
  formReactFlowInstance: ReactFlowInstance | null;
  currentWorkflowParameters: WorkflowParameter[];
  // keys used to force a rerender of edge or node if a component is using a store
  // setting a new key will trigger a component rerender even if props don't change
  edgeKeys: Record<string, string>;
  nodeKeys: Record<string, string>;
  isDraggingNode: boolean;
  isConnectingNodes: boolean;
};

type Actions = {
  setSelectedNode: (selectedNode: WorkflowNode | null) => void;
  setSelectedEmbedWorkflows: (selectedEmbedWorkflows: Workflow[]) => void;
  setMainReactFlowInstance: (instance: ReactFlowInstance | null) => void;
  setFormReactFlowInstance: (instance: ReactFlowInstance | null) => void;
  setCurrentWorkflowParameters: (parameters: WorkflowParameter[]) => void;
  setEdgeKey: (edgeId: string, key?: string) => void;
  setNodeKey: (nodeId: string, key?: string) => void;
  setIsDraggingNode: (isDraggingNode: boolean) => void;
  setIsConnectingNodes: (isConnectingNodes: boolean) => void;
};

export type FlowSlice = State & Actions;

export const createFlowSlice: StateCreator<FlowSlice, [['zustand/immer', never]], [], FlowSlice> = (set) => ({
  selectedNode: null,
  selectedEmbedWorkflows: [],
  mainReactFlowInstance: null,
  formReactFlowInstance: null,
  currentWorkflowParameters: [],
  edgeKeys: {},
  nodeKeys: {},
  isDraggingNode: false,
  isConnectingNodes: false,
  setSelectedNode: (selectedNode) => set(() => ({ selectedNode })),
  setMainReactFlowInstance: (mainReactFlowInstance: ReactFlowInstance | null) => set(() => ({ mainReactFlowInstance })),
  setFormReactFlowInstance: (formReactFlowInstance: ReactFlowInstance | null) => set(() => ({ formReactFlowInstance })),
  setCurrentWorkflowParameters: (currentWorkflowParameters) => set(() => ({ currentWorkflowParameters })),
  setEdgeKey: (edgeId, key) =>
    set((state) => ({
      edgeKeys: { ...state.edgeKeys, [edgeId]: key ?? new Date().toISOString() },
    })),
  setNodeKey: (nodeID, key) =>
    set((state) => ({
      nodeKeys: { ...state.nodeKeys, [nodeID]: key ?? new Date().toISOString() },
    })),
  setSelectedEmbedWorkflows: (selectedEmbedWorkflows: Workflow[]) => set(() => ({ selectedEmbedWorkflows })),
  setIsDraggingNode: (isDraggingNode: boolean) => set(() => ({ isDraggingNode })),
  setIsConnectingNodes: (isConnectingNodes: boolean) => set(() => ({ isConnectingNodes })),
});
